module.exports = __webpack_public_path__ + "img/folder.1056d8c9.svg";